const percentageComplete = ({ completed, total } : { completed: number, total: number }): number => {
  if (completed === 0 || total === 0) {
    return 0;
  }
  return (completed / total) * 100;
};

export default percentageComplete;